module.exports = __webpack_public_path__ + "static/media/bogota12.cc6c85f1.jpg";